export const categoryTileEllipsesApplied = (CharacterCountEllipsis) => {

    let categoryEllipses = new CharacterCountEllipsis('', 75, 1400, { mobile: 576, tablet: 992, desktop: 1280 });

    if (document.querySelectorAll('.category-tile__content')) {
        const content = document.querySelectorAll('.category-tile__content');

        categoryEllipses.removeOrphanPTags(content);
        categoryEllipses.removeOrphanBreakTags(content);

        content.forEach(item => {
            if (item.querySelectorAll('p')[0]) {
                let paragraphTarget = item.querySelectorAll('p')[0];
                let textContent = paragraphTarget.innerHTML;

                let trimmedResult = categoryEllipses.getTrimmedStringForDevices(textContent);
                paragraphTarget.innerHTML = trimmedResult;
            }
        });

        const contentDescription = document.querySelectorAll('.category-tile__content > p:first-of-type');
        categoryEllipses.matchHeightOnLoad(contentDescription);
    }
}